(function () {
  function parseDate(value) {
    if (!value) return null;
    var normalized = value.indexOf('T') === -1 ? value.replace(' ', 'T') : value;
    var date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function renderCountdown(root) {
    var target = parseDate(root.dataset.target);
    if (!target) return;

    var remaining = Math.max(0, target.getTime() - Date.now());
    var totalSeconds = Math.floor(remaining / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var dayItem = root.querySelector('[data-unit="days"]');

    if (dayItem) dayItem.hidden = remaining <= 86400000;
    if (remaining <= 86400000) hours = Math.floor(totalSeconds / 3600);

    var values = { days: days, hours: hours, minutes: minutes, seconds: seconds };
    Object.keys(values).forEach(function (unit) {
      var node = root.querySelector('[data-value="' + unit + '"]');
      if (node) node.textContent = pad(values[unit]);
    });

    if (remaining === 0 && root.dataset.expiredText) {
      root.setAttribute('aria-label', root.dataset.expiredText);
    }
  }

  function initCountdowns(scope) {
    var roots = scope.querySelectorAll('[data-sb-countdown]');
    roots.forEach(function (root) {
      renderCountdown(root);
      window.setInterval(function () { renderCountdown(root); }, 1000);
    });
  }

  function initPlaces(scope) {
    scope.querySelectorAll('[data-sb-places]').forEach(function (root) {
      var mode = root.dataset.mode || 'manual';
      var remaining = Number(root.dataset.manual || 0);
      var initial = Math.max(0, Number(root.dataset.initial || remaining));
      var minimum = Math.max(0, Number(root.dataset.minimum || 0));
      var rate = Math.min(100, Math.max(0, Number(root.dataset.rate || 0))) / 100;
      var intervalHours = Math.max(1, Number(root.dataset.intervalHours || 24));
      var start = parseDate(root.dataset.start);
      var total = Math.max(initial, Number(root.dataset.total || initial));

      if (mode === 'automatic' && start && initial > 0) {
        var intervalDuration = intervalHours * 60 * 60 * 1000;
        var elapsedIntervals = Math.max(0, Math.floor((Date.now() - start.getTime()) / intervalDuration));
        var estimatedRegistrations = Math.round(total * rate * elapsedIntervals);
        remaining = Math.max(minimum, initial - estimatedRegistrations);
      }

      remaining = Math.min(total, Math.max(0, remaining));
      var registered = Math.max(0, total - remaining);
      var percentage = total > 0 ? Math.min(100, Math.max(0, (registered / total) * 100)) : 0;
      var formatter = new Intl.NumberFormat('fr-FR');
      var remainingNode = root.querySelector('[data-remaining]');
      var registeredNode = root.querySelector('[data-registered]');
      var bar = root.querySelector('[data-progress]');

      if (remainingNode) remainingNode.textContent = formatter.format(remaining);
      if (registeredNode) registeredNode.textContent = formatter.format(registered);
      if (bar) bar.style.width = percentage + '%';
    });
  }

  function initAnchors(scope) {
    scope.querySelectorAll('a[href="#sb-vip-form"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById('sb-vip-form');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(function () {
          var input = target.querySelector('input[type="email"]');
          if (input) input.focus({ preventScroll: true });
        }, 500);
      });
    });
  }

  function initDiscoverySliders(scope) {
    var sections = Array.prototype.slice.call(scope.querySelectorAll('.sb-discovery'));
    if (scope.matches && scope.matches('.sb-discovery')) sections.unshift(scope);

    sections.forEach(function (section) {
      if (section.dataset.sbDiscoveryReady === 'true') return;

      var cards = section.querySelector('.sb-discovery__cards');
      var previous = section.querySelector('[data-sb-discovery-prev]');
      var next = section.querySelector('[data-sb-discovery-next]');
      var progress = section.querySelector('.sb-discovery__scroll span');
      if (!cards || !previous || !next || !progress) return;

      function items() {
        return Array.prototype.slice.call(cards.querySelectorAll('.sb-discovery__card'));
      }

      function maximumScroll() {
        return Math.max(0, cards.scrollWidth - cards.clientWidth);
      }

      function targetFor(card) {
        var firstCard = cards.querySelector('.sb-discovery__card');
        if (!card || !firstCard) return 0;
        return Math.min(maximumScroll(), Math.max(0, card.offsetLeft - firstCard.offsetLeft));
      }

      function currentIndex() {
        var cardItems = items();
        var closestIndex = 0;
        var closestDistance = Infinity;

        cardItems.forEach(function (card, index) {
          var distance = Math.abs(cards.scrollLeft - targetFor(card));
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      function goTo(index) {
        var cardItems = items();
        if (!cardItems.length) return;

        var destinationIndex = Math.max(0, Math.min(cardItems.length - 1, index));
        var left = targetFor(cardItems[destinationIndex]);

        if (typeof cards.scrollTo === 'function') {
          cards.scrollTo({ left: left, behavior: 'smooth' });
        } else {
          cards.scrollLeft = left;
        }
      }

      function update() {
        var cardItems = items();
        var maximum = maximumScroll();
        var index = currentIndex();
        var percentage = cardItems.length > 1 ? index / (cardItems.length - 1) : 0;
        progress.style.setProperty('--sb-discovery-progress', (28 + percentage * 72) + '%');
        previous.disabled = maximum <= 1 || index <= 0;
        next.disabled = maximum <= 1 || index >= cardItems.length - 1;
      }

      previous.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(currentIndex() - 1);
      });

      next.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(currentIndex() + 1);
      });

      cards.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      if (typeof ResizeObserver !== 'undefined') {
        var resizeObserver = new ResizeObserver(update);
        resizeObserver.observe(cards);
      }

      section.dataset.sbDiscoveryReady = 'true';
      window.requestAnimationFrame(update);
      window.setTimeout(update, 100);
      window.setTimeout(update, 500);
    });
  }

  function init(scope) {
    initCountdowns(scope);
    initPlaces(scope);
    initAnchors(scope);
    initDiscoverySliders(scope);
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.setInterval(function () { initPlaces(document); }, 60000);

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
